import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useSkills = (type) => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useQuery({
    queryKey: ['skills', type],
    queryFn: async () => {
      const url = type ? `${prefix}/cms/skills?type=${type}` : `${prefix}/cms/skills`;
      const result = await restClient({ url });
      return result;
    },
    staleTime: 0, 
    cacheTime: 0
  });
};
